<template>
    <div>
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-select v-model="params.type" clearable placeholder="统计类型" class="search-item">
                    <el-option
                        v-for="item in types"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select v-model="params.shopId" clearable placeholder="所属店铺" class="search-item">
                    <el-option
                        v-for="item in shops"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <sn-user-search-input
                    title="业务员"
                    class="search-item"
                    @change="
              (a) => {
                params.seller = a;
              }
            "
                ></sn-user-search-input>
            </el-row>
            <el-row class="search-row">
                <el-date-picker
                    type="date"
                    placeholder="统计时间（开始）"
                    v-model="params.startTime"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-date-picker
                    type="date"
                    placeholder="统计时间（截止）"
                    v-model="params.endTime"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-button type="primary" size="small" @click="search">搜索</el-button>
            </el-row>
        </div>

        <div :style="'width: 100%;overflow: auto;height:' + ($tools.mainHeight() - 105) + 'px'">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>店铺统计(询盘orTM人数)</span>
                </div>
                <div id="shopAssign"></div>
            </el-card>

            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>按人统计(询盘人数)</span>
                </div>
                <div id="sellerAssign"></div>
            </el-card>

            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>按人统计(TM人数)</span>
                </div>
                <div id="sellerTm"></div>
            </el-card>
        </div>
    </div>
</template>

<script>
import SnUserSearchInput from "../components/SnUserSearchInput.vue";

import {
    Chart,
    registerInteraction,
    registerAction,
    ActionConstructor,
    getDelegationObject,
} from "@antv/g2";

export default {
    components: { SnUserSearchInput },
    data() {
        return {
            types: [
                { id: "M", name: "按月" },
                { id: "D", name: "按日" },
            ],
            shops: [],
            params: {
                shopId: null,
                seller: null,
                type: "M",
            },
            reportData: null,
            char: { shopAssign: null, sellerAssign: null, sellerTm: null },
        };
    },
    methods: {
        getShops() {
            let _this = this;

            _this.$http.post(
                ["alibaba/shop/all"],
                [
                    function (data) {
                        _this.shops = data;
                    },
                ],
                ".alibaba-buyer-table"
            );
        },

        search() {
            let _this = this;

            _this.$http.post(
                ["alibaba/assign/report", _this.params],
                [
                    function (data) {
                        _this.reportData = data;

                        _this.renderShopAssign();
                        _this.renderSellerAssign();
                        _this.renderSellerTm();
                    },
                ],
                ".alibaba-buyer-table"
            );
        },

        renderChart(name) {
            let _this = this;

            if (!_this.char[name]) {
                _this.char[name] = new Chart({
                    container: name,
                    autoFit: true,
                    height: 450,
                });
            }

            return _this.char[name];
        },

        renderSellerAssign() {
            let _this = this;
            let chart = _this.renderChart("sellerAssign");
            let data = _this.reportData.sellerData;

            let sellerData = [];

            for (var i in data) {
                sellerData.push(_this.toSellerData(data[i], "assign"));
            }

            chart.tooltip({
                showMarkers: false,
                shared: true,
            });

            chart
                .interval()
                .position("date*value")
                .color("type")
                .adjust([
                    {
                        type: "dodge",
                        marginRatio: 0,
                    },
                ]);

            chart.data(sellerData);

            chart.render();
        },

        renderSellerTm() {
            let _this = this;
            let chart = _this.renderChart("sellerTm");
            let data = _this.reportData.sellerData;

            let sellerData = [];

            for (var i in data) {
                sellerData.push(_this.toSellerData(data[i], "tm"));
            }

            
            chart.tooltip({
                showMarkers: false,
                shared: true,
            });

            chart
                .interval()
                .position("date*value")
                .color("type")
                .adjust([
                    {
                        type: "dodge",
                        marginRatio: 0,
                    },
                ]);

            chart.data(sellerData);
            chart.render();
        },
        renderShopAssign() {
            let _this = this;
            let chart = _this.renderChart("shopAssign");
            let data = _this.reportData.shopData;

            let shopData = [];

            for (var i in data) {
                shopData.push(_this.toShopData(data[i], "tm"));
                shopData.push(_this.toShopData(data[i], "assign"));
                shopData.push(_this.toShopData(data[i], "garbage"));
                shopData.push(_this.toShopData(data[i], "garbageTm"));
            }

            chart.data(shopData);

            chart.tooltip({
                shared: true,
            });

            chart.line().position("date*value").shape("smooth").color("type");

            chart.render();
        },


        toShopData(data, name) {
            let typeName = {
                tm: "TM",
                assign: "询盘",
                garbage: "垃圾询盘",
                garbageTm: "垃圾TM",
            };
            return { date: data.date, type: typeName[name], value: data[name] };
        },

        toSellerData(data, name) {
            return {
                date: data.date,
                type: data.sellerName ? data.sellerName : data.seller + "",
                value: data[name],
            };
        },
    },
    mounted() {
        this.getShops();
    },
};
</script>

<style lang="scss" scoped>
</style>